<template lang="html">

    <div class="address-select">
          <div class="seekLine">
              <el-select
                style="width:480px"
                v-model="selectId" filterable
                remote
                placeholder="请输入关键词"
                size="small"
                :remote-method="adsSeek"
                @change="selectChange"
                :loading="loading">
                <el-option
                  v-for="item in adsArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                    <div class="opLine">
                          <div class="mText"> <span>{{item.name}}</span> </div>
                          <div class="subText"> <span>{{item.address}}</span> </div>
                    </div>
                </el-option>
              </el-select>

              <el-button v-if="selectType!=1" size="small" style="margin-left:20px;width:80px;" @click="addressSet('add')" type="primary">添加</el-button>
          </div>

          <div v-if="selectType!=1" style="margin-top:18px;">
              <div v-for="item in selectedList" class="dLine">
                  <div class="iName">
                        <span class="mText">{{item.name}}</span>
                        <span class="sText">（{{item.address}}）</span>
                        <span @click="addressSet('remove',item.name)" class="dbtn">删除</span>
                  </div>
                  <div class="iText">

                  </div>
              </div>
          </div>



    </div>

</template>

<script>
export default {
    name:'adsSelect',
    props:['adsList','selectType'],
    watch:{
        adsList:function(e){
            if(this.selectType == 1){
                this.itemStore = this.adsList[0];
                // this.selectId = this.itemStore.name+"("+this.itemStore.address+")";
                this.keyword = this.itemStore.name;
                this.searchService.search(this.keyword);
            }else{
                this.selectedList = e;
            }

        }
    },
    data(){
        return{
            keyword:'',
            selectId:'',
            locMap:{},
            adsArr:[],
            selectedList:[],
            itemStore:{}
        }
    },
    methods:{
        adsSeek(e){
          if(e){
              this.searchService.search(e);
          }else{
              this.adsArr = [];
          }
        },
        selectChange(e){
           this.itemStore = this.locMap[e];
           if(this.selectType == 1){
              this.$emit('selected',this.itemStore);
           }
        },
        addressSet(type,name){
           if(type == 'add'){
               if(this.itemStore.address){
                   this.selectedList.unshift(this.itemStore);
                   this.itemStore = '';
                   this.keyword = '';
               }
           }else if(type == 'remove'){
               this.selectedList.forEach((item,index) => {
                   if(item.name == name){
                      this.selectedList.splice(index,1);
                      return;
                   }
               })
           }
        }
    },
    created:function(){
        var vues = this;
        this.searchService = new qq.maps.SearchService({
            location:'北京市',
            complete:function(res){
                vues.adsArr = res.detail.pois;
                vues.adsArr.forEach(item => {
                    if(vues.selectType == 1&&vues.keyword==item.name){
                        vues.selectId =item.id;
                    }
                    vues.locMap[item.id] = item;
                })
            }
        })
    }
}
</script>

<style lang="scss" scoped>

.dLine{
    .mText{
       color: #666666;
    }
    .sText{
       font-size: 14px;
       color: #AEAEAE;
    }
    .dbtn{
        margin-left: 20px;
        font-size: 14px;
        color: #409EFF;
        cursor: pointer;
    }
}

.opLine{
    line-height: 20px;
    padding-top: 10px;
    .subText{
        color: #CECECE;
        max-width: 450px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
}
.seekLine{
    display:flex;
}
.el-select{
   display:block;
}

.el-select-dropdown__item{
    height: 60px !important;
}

</style>



// WEBPACK FOOTER //
// adsSelect.vue?83b4817a